import type { TopicEnrichment } from './temariosEnriched';

export const ENRICHMENT_GENERICO: Record<string, TopicEnrichment> = {
  'gen-1': {
    index: [
      'Concepto y naturaleza de la Constitución',
      'Estructura constitucional y título preliminar',
      'Derechos fundamentales y deberes',
      'Garantías constitucionales y amparo',
      'Reforma constitucional',
    ],
    normativa: ['Constitución Española de 1978'],
  },
  'gen-2': {
    index: [
      'Naturaleza y composición del Tribunal Constitucional',
      'Competencias de control de constitucionalidad',
      'Recurso de inconstitucionalidad y cuestión de inconstitucionalidad',
      'Recurso de amparo constitucional',
      'Conflictos de competencia y efectos de las sentencias',
    ],
    normativa: ['Constitución Española', 'LO 2/1979, del Tribunal Constitucional'],
  },
  'gen-3': {
    index: [
      'Cortes Generales: configuración constitucional',
      'Congreso de los Diputados y Senado',
      'Estatuto de parlamentarios',
      'Función legislativa',
      'Función de control del Gobierno y órganos auxiliares',
    ],
    normativa: ['Constitución Española, Título III'],
  },
  'gen-4': {
    index: [
      'Principios constitucionales del Poder Judicial',
      'Consejo General del Poder Judicial',
      'Organización judicial y órganos jurisdiccionales',
      'Tribunal Supremo y Ministerio Fiscal',
      'Independencia, unidad jurisdiccional y exclusividad',
    ],
    normativa: ['Constitución Española', 'LO 6/1985, del Poder Judicial'],
  },
  'gen-5': {
    index: [
      'El Gobierno en la Constitución',
      'Presidente, Vicepresidentes y Ministros',
      'Nombramiento, cese y responsabilidad',
      'Relaciones Gobierno-Cortes',
      'Principios de actuación administrativa',
    ],
    normativa: ['Constitución Española', 'Ley 50/1997, del Gobierno', 'Ley 40/2015, LRJSP'],
  },
  'gen-6': {
    index: [
      'Estado autonómico y organización territorial',
      'Competencias del Estado y de las Comunidades Autónomas',
      'Estatutos de Autonomía',
      'Administración periférica y local',
      'Cooperación y coordinación interadministrativa',
    ],
    normativa: ['Constitución Española, Título VIII'],
  },
  'gen-7': {
    index: [
      'Origen y evolución de la Unión Europea',
      'Tratados constitutivos y reforma de la Unión',
      'Instituciones principales de la UE',
      'Fuentes del Derecho de la UE',
      'Primacía, efecto directo y ciudadanía europea',
    ],
    normativa: ['TUE', 'TFUE', 'Carta de los Derechos Fundamentales de la UE'],
  },
  'gen-8': {
    index: [
      'Publicidad activa',
      'Derecho de acceso a la información pública',
      'Límites del acceso y protección de datos',
      'Procedimiento de solicitud y reclamación',
      'Consejo de Transparencia y buen gobierno',
    ],
    normativa: ['Ley 19/2013 de Transparencia'],
  },
  'gen-9': {
    index: [
      'Concepto de Gobierno Abierto',
      'Transparencia, participación y colaboración',
      'Datos abiertos y rendición de cuentas',
      'Agenda 2030 y Objetivos de Desarrollo Sostenible',
      'Aplicación en la administración pública',
    ],
    normativa: ['Ley 19/2013', 'Agenda 2030', 'ODS'],
  },
  'gen-10': {
    index: [
      'Jerarquía normativa y sistema de fuentes',
      'Constitución, ley y reglamento',
      'Principios generales del Derecho',
      'Jurisprudencia y costumbre',
      'Reserva de ley y supletoriedad',
    ],
    normativa: ['Constitución Española', 'Código Civil'],
  },
  'gen-11': {
    index: [
      'Concepto y clases de acto administrativo',
      'Elementos del acto y presunción de validez',
      'Motivación, forma y eficacia',
      'Notificación y publicación',
      'Nulidad, anulabilidad y revisión',
    ],
    normativa: ['Ley 39/2015', 'Ley 40/2015'],
  },
  'gen-12': {
    index: [
      'Interesados, capacidad y representación',
      'Fases del procedimiento administrativo',
      'Plazos, cómputo y ampliación',
      'Notificaciones, registros y archivo',
      'Silencio administrativo y recursos',
    ],
    normativa: ['Ley 39/2015'],
  },
  'gen-13': {
    index: [
      'Principios de actuación del sector público',
      'Órganos administrativos y competencia',
      'Abstención y recusación',
      'Funcionamiento electrónico',
      'Convenios y responsabilidad patrimonial',
    ],
    normativa: ['Ley 40/2015'],
  },
  'gen-14': {
    index: [
      'Principios de la potestad sancionadora',
      'Tipificación de infracciones y sanciones',
      'Procedimiento sancionador',
      'Prescripción y caducidad',
      'Ejecución forzosa y multas coercitivas',
    ],
    normativa: ['Ley 39/2015', 'Ley 40/2015'],
  },
  'gen-15': {
    index: [
      'Presupuestos de la responsabilidad patrimonial',
      'Daño antijurídico y relación de causalidad',
      'Procedimiento de reclamación',
      'Cuantificación e indemnización',
      'Responsabilidad concurrente y acción de regreso',
    ],
    normativa: ['Ley 40/2015'],
  },
  'gen-16': {
    index: [
      'Objeto y ámbito de la jurisdicción contencioso-administrativa',
      'Órganos jurisdiccionales y legitimación',
      'Procedimiento ordinario y abreviado',
      'Medidas cautelares',
      'Recursos y ejecución de sentencias',
    ],
    normativa: ['Ley 29/1998, LJCA'],
  },
  'gen-17': {
    index: [
      'Utilidad pública e interés social',
      'Sujetos y objeto expropiable',
      'Justiprecio y procedimiento de fijación',
      'Ocupación, pago y toma de posesión',
      'Reversión y garantías del expropiado',
    ],
    normativa: ['Ley de Expropiación Forzosa de 1954'],
  },
  'gen-18': {
    index: [
      'Ámbito de aplicación de la LCSP',
      'Principios de contratación pública',
      'Preparación del contrato',
      'Capacidad, solvencia y adjudicación',
      'Ejecución, modificación y extinción',
    ],
    normativa: ['Ley 9/2017, LCSP'],
  },
  'gen-19': {
    index: [
      'Contratos de obras, servicios y suministros',
      'Concesión de obras y concesión de servicios',
      'Procedimientos de adjudicación',
      'Criterios de valoración y contratación menor',
      'Recurso especial en materia de contratación',
    ],
    normativa: ['Ley 9/2017, LCSP'],
  },
  'gen-20': {
    index: [
      'Principios de autonomía local',
      'Municipio, provincia y otras entidades locales',
      'Competencias municipales y provinciales',
      'Potestades locales',
      'Servicios mínimos y cooperación interadministrativa',
    ],
    normativa: ['Ley 7/1985, LBRL', 'RDLeg 781/1986, TRRL'],
  },
  'gen-21': {
    index: [
      'Alcaldía, Pleno y Junta de Gobierno Local',
      'Comisiones informativas y órganos complementarios',
      'Convocatoria y celebración de sesiones',
      'Quórum, votaciones y mayorías',
      'Actas y régimen de funcionamiento',
    ],
    normativa: ['RD 2568/1986, ROF'],
  },
  'gen-22': {
    index: [
      'Sistema electoral local',
      'Elección de concejales y alcaldes',
      'Diputaciones provinciales',
      'Moción de censura y cuestión de confianza',
      'Vacantes y sustituciones',
    ],
    normativa: ['LO 5/1985, LOREG'],
  },
  'gen-23': {
    index: [
      'Recursos de las entidades locales',
      'Presupuesto local y principios presupuestarios',
      'Impuestos, tasas y contribuciones especiales',
      'Recaudación y gestión tributaria',
      'Financiación y crédito local',
    ],
    normativa: ['RDLeg 2/2004, TRLRHL'],
  },
  'gen-24': {
    index: [
      'Clases de empleados públicos',
      'Adquisición y pérdida de la condición de funcionario',
      'Derechos y deberes',
      'Situaciones administrativas',
      'Régimen disciplinario y código de conducta',
    ],
    normativa: ['RDLeg 5/2015, TREBEP'],
  },
  'gen-25': {
    index: [
      'Principios constitucionales de acceso',
      'Oferta de empleo público y sistemas selectivos',
      'Órganos de selección',
      'Provisión de puestos y carrera profesional',
      'Toma de posesión y nombramiento',
    ],
    normativa: ['RDLeg 5/2015, TREBEP', 'RD 364/1995'],
  },
  'gen-26': {
    index: [
      'Derechos individuales y colectivos',
      'Retribuciones y jornada',
      'Permisos, licencias y vacaciones',
      'Deberes, incompatibilidades y responsabilidad',
      'Representación y negociación colectiva',
    ],
    normativa: ['RDLeg 5/2015, TREBEP'],
  },
  'gen-27': {
    index: [
      'Régimen general de incompatibilidades',
      'Actividad pública y privada',
      'Autorización de compatibilidad',
      'Excepciones y supuestos permitidos',
      'Consecuencias del incumplimiento',
    ],
    normativa: ['Ley 53/1984, de Incompatibilidades'],
  },
  'gen-28': {
    index: [
      'Régimen general de Seguridad Social',
      'MUFACE y mutualismo administrativo',
      'Clases pasivas y jubilación',
      'Prestaciones económicas y asistenciales',
      'Incapacidad, viudedad y orfandad',
    ],
    normativa: ['RDL 8/2015, TRLGSS'],
  },
  'gen-29': {
    index: [
      'Principios de la Ley General Presupuestaria',
      'Estructura y contenido del presupuesto',
      'Ciclo presupuestario',
      'Ejecución y modificaciones',
      'Contabilidad pública y cierre',
    ],
    normativa: ['Ley 47/2003, LGP'],
  },
  'gen-30': {
    index: [
      'Principios de estabilidad y sostenibilidad',
      'Déficit, deuda y regla de gasto',
      'Medidas preventivas y correctivas',
      'Planes económico-financieros',
      'Seguimiento y cumplimiento',
    ],
    normativa: ['LO 2/2012, de Estabilidad Presupuestaria'],
  },
  'gen-31': {
    index: [
      'Función interventora',
      'Control financiero permanente',
      'Auditoría pública',
      'Tribunal de Cuentas',
      'Responsabilidad contable y rendición de cuentas',
    ],
    normativa: ['RD 424/2017', 'LO 2/1982, del Tribunal de Cuentas'],
  },
  'gen-32': {
    index: [
      'Principios del tratamiento de datos',
      'Bases de legitimación',
      'Derechos de acceso, rectificación, supresión y oposición',
      'Responsable y encargado del tratamiento',
      'Seguridad, brechas y evaluaciones de impacto',
    ],
    normativa: ['Reglamento (UE) 2016/679, RGPD'],
  },
  'gen-33': {
    index: [
      'Adaptación española del RGPD',
      'Derechos digitales',
      'Tratamiento de datos en el sector público',
      'Videovigilancia y tratamientos especiales',
      'Menores, garantías y régimen sancionador',
    ],
    normativa: ['LO 3/2018, LOPDGDD'],
  },
  'gen-34': {
    index: [
      'Principio de igualdad de trato y oportunidades',
      'Discriminación directa e indirecta',
      'Transversalidad de género',
      'Planes de igualdad',
      'Acciones positivas en el empleo público',
    ],
    normativa: ['LO 3/2007, de Igualdad'],
  },
  'gen-35': {
    index: [
      'Concepto y ámbito de la violencia de género',
      'Prevención y sensibilización',
      'Protección y asistencia a víctimas',
      'Órdenes de protección y coordinación',
      'Medidas institucionales',
    ],
    normativa: ['LO 1/2004, de Violencia de Género'],
  },
  'gen-36': {
    index: [
      'Consentimiento y violencia sexual',
      'Prevención y detección',
      'Atención integral a víctimas',
      'Derechos, reparación y acompañamiento',
      'Formación institucional y respuesta pública',
    ],
    normativa: ['Ley 4/2023, de Garantía Integral de la Libertad Sexual'],
  },
  'gen-37': {
    index: [
      'Principios del Derecho Penal',
      'Teoría general del delito',
      'Autoría, participación y responsabilidad',
      'Penas y medidas de seguridad',
      'Aplicación de la ley penal en el tiempo y en el espacio',
    ],
    normativa: ['LO 10/1995, del Código Penal'],
  },
  'gen-38': {
    index: [
      'Prevaricación administrativa',
      'Cohecho y tráfico de influencias',
      'Malversación y caudales públicos',
      'Desobediencia y denegación de auxilio',
      'Custodia de documentos y corrupción pública',
    ],
    normativa: ['LO 10/1995, del Código Penal'],
  },
  'gen-39': {
    index: [
      'Jurisdicción y competencia penal',
      'Denuncia, querella y atestado',
      'Instrucción y diligencias previas',
      'Prueba y juicio oral',
      'Sentencia, recursos y ejecución penal',
    ],
    normativa: ['LECrim', 'LOPJ'],
  },
  'gen-40': {
    index: [
      'Detención y derechos del detenido',
      'Prisión provisional y libertad provisional',
      'Fianzas y medidas cautelares',
      'Órdenes de protección y medidas reales',
      'Procedimiento abreviado',
    ],
    normativa: ['LECrim'],
  },
  'gen-41': {
    index: [
      'Ámbito de aplicación de la seguridad ciudadana',
      'Identificación y comprobaciones policiales',
      'Registros, controles y potestades de policía',
      'Infracciones y sanciones',
      'Autoridad competente y garantías',
    ],
    normativa: ['LO 4/2015, de Seguridad Ciudadana'],
  },
  'gen-42': {
    index: [
      'Principios básicos de actuación',
      'Funciones de Policía Nacional y Guardia Civil',
      'Policías autonómicas y locales',
      'Coordinación y colaboración entre cuerpos',
      'Régimen básico organizativo',
    ],
    normativa: ['LO 2/1986, de Fuerzas y Cuerpos de Seguridad'],
  },
};
